import { ValidatorFn, AbstractControl, ValidationErrors } from "@angular/forms";

/** Custom Validator for Selectors on Dynamic Form */
export function isObjectOrNothingValidator(): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {
		const forbidden = typeof control.value != 'object' && control.value != ""; //-- this allows something like JBT Standard Observations to be saved as nothing ("") in case the user is trying to unset the value. --Kirk T. Sherer, June 30, 2021. 
		return forbidden ? { isObject: { value: control.value } } : null;
	};
}